module.exports = __webpack_public_path__ + "static/media/zluty-semafor-readonly.a8ff834d.svg";